module.exports = __webpack_public_path__ + "img/gauge-max.44548c1d.svg";